import { http } from '@/api/http';
import { ApiResponseBody, PaginatedApiResponseBody } from '@/api/types';
import {
  getOpoCaseApiUrl,
  OpoCase,
  OpoCaseListFilters,
  CreateOpoCaseRequestBody,
  UpdateDonorDataRequestBody,
} from '@/api/apis/case/opo-case';

const getOpoCaseList = async (params: OpoCaseListFilters) => {
  const res = await http.get<PaginatedApiResponseBody<OpoCase>>(getOpoCaseApiUrl.opoCases(), {
    params,
    paramsSerializer: { indexes: null },
  });
  return res.data.data;
};

const getOpoCaseById = async (caseId: string) => {
  const res = await http.get<ApiResponseBody<OpoCase>>(getOpoCaseApiUrl.opoCaseById(caseId));
  return res.data.data;
};

const createOpoDraftCase = async (data: CreateOpoCaseRequestBody) => {
  const res = await http.post<ApiResponseBody<OpoCase>>(getOpoCaseApiUrl.opoCaseCreateDraft(), data);
  return res.data.data;
};

const updateOpoCaseDonorData = async (caseId: string, data: UpdateDonorDataRequestBody) => {
  const res = await http.patch<ApiResponseBody<OpoCase>>(getOpoCaseApiUrl.opoCaseDonorData(caseId), data);
  return res.data.data;
};

export const opoCaseApiFetcher = {
  getOpoCaseList,
  getOpoCaseById,
  createOpoDraftCase,
  updateOpoCaseDonorData,
};
